import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Connect your wallet',
});
